import { render, staticRenderFns } from "./EducationProtocolEdit.vue?vue&type=template&id=24fcf2a0&"
import script from "./EducationProtocolEdit.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocolEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports